import { Injectable } from '@angular/core';
import { Observable, Subject, BehaviorSubject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

@Injectable()
export class LastFieldInteractionService {
	public lastAccessField$: Observable<string | null>;
	private lastAccessField: Subject<string | null>;

	public constructor() {
		this.lastAccessField = new BehaviorSubject(null);
		this.lastAccessField$ = this.lastAccessField.asObservable().pipe(distinctUntilChanged());
	}

	public setFieldId(fieldId: string): void {
		this.lastAccessField.next(fieldId);
	}
}
